import { Link } from "react-router-dom";
import { createColumnHelper } from "@tanstack/react-table";
import ExpandableDataTable from "components/admin/ExpandableDataTable";
import usePaginatedResource from "hooks/usePaginatedResource";
import {
  settlementColumns,
  settlementExportColumns,
  settlementPeriod,
  renderSettlementDetail,
  SettlementDetailModal,
  MoneyTimelineLink,
  useSettlementDetail,
  viewButtonClass,
} from "views/portal/settlements";

const columnHelper = createColumnHelper();
// Filtered by the API, not here: filtering a page in the browser while paging against
// the unfiltered total made a page of non-payout settlements render empty under a
// footer that still counted them.
const PAYOUT_STATUSES = "PROCESSING,PAID,FAILED,REVERSED";

export default function PayoutsPage() {
  const { items, total, loading, error, page, setPage, pageSize, setPageSize, refetch, exportAll } = usePaginatedResource("/portal/settlements", {
    pageSize: 20,
    itemsKey: "settlements",
    pollMs: 15000,
    extraParams: { status: PAYOUT_STATUSES },
  });

  const { detail, detailLoading, detailError, detailOpen, openDetail, closeDetail } = useSettlementDetail();

  const columns = settlementColumns(columnHelper);

  return (
    <div>
      <ExpandableDataTable
        title="Payout history"
        subtitle="Every settlement that has been sent for payment, with the calculation behind it."
        columns={columns}
        exportColumns={settlementExportColumns}
        data={items}
        loading={loading}
        error={error}
        onRetry={refetch}
        emptyMessage="No payouts have been submitted for your organization yet."
        page={page}
        pageSize={pageSize}
        total={total}
        onPageChange={setPage}
      onPageSizeChange={setPageSize}
        exportFilename="payouts"
        onExportAll={exportAll}
        rowLabel={(s) => `payout ${settlementPeriod(s)}`}
        headerActions={<MoneyTimelineLink />}
        renderDetail={renderSettlementDetail}
        renderActions={(s) => (
          <>
            <button type="button" onClick={() => openDetail(s.id)} className={viewButtonClass()}>
              View full record
            </button>
            <Link to="/portal/money-timeline?type=CLIENT_SETTLEMENT" className={viewButtonClass()}>
              See it on the money timeline
            </Link>
          </>
        )}
      />

      {detailOpen && <SettlementDetailModal settlement={detail} loading={detailLoading} error={detailError} onClose={closeDetail} />}
    </div>
  );
}
